import { createAction, props } from '@ngrx/store';
import { IClientsState } from './clients.state';

export enum ClientsActions {
  ClientsRequested = '[Clients] Clients Requested',
  ClientsLoaded = '[Clients] Clients Loaded',
  ClientsError = '[Clients] Clients Error',
}

export const ClientsRequested = createAction(ClientsActions.ClientsRequested, props<{userId: string}>());

export const ClientsLoaded = createAction(ClientsActions.ClientsLoaded, props<{ clients: IClientsState['clients'] }>());

export const ClientsError = createAction(ClientsActions.ClientsError);